export default __webpack_public_path__ + "static/media/how-we-met.50415f0f.jpg";